<template>
  <div class="expert">
    <img :src="banner.imgUrl" class="cov-img page-banner" alt="">
    <div class="center" v-show="editType === 0">
      <pane-title title="专家委员会" sub-title="Expert Committee" />

      <div class="list">
        <div class="item" v-for="item in list" :key="list.id">
          <img :src="item.pcImgUrl" alt=""  @click="jumpDetail(item)">
          <div  @click="jumpDetail(item)">{{item.title}}</div>
<!--          <p v-for="(citem, ci) in getIntro(item.description)" :key="ci">-->
<!--            {{citem}}-->
<!--          </p>-->
        </div>
      </div>

      <div class="point-msg">
        * {{lang === 'zh' ? '以上按首字母顺序排列' : 'Sort by alphabetical initials of last names'}}
      </div>
    </div>
    <div class="center" v-show="editType === 1">
      <pane-title title="专家简介" sub-title="Expert Profile" />
      <div class="content">
        <img :src="currentExpert.pcImgUrl" alt="">
        <div class="detail-box">
          <p>
            <span>{{currentExpert.title}}</span>
            <span>{{getDesc(currentExpert.description)}}</span>
          </p>
          <div class="con-box">
            <p
              class="txt txt-align" :class="lang === 'en' ? 'en-txt-align' : ''"
              v-for="(item, i) in currentExpert.content.split('|')"
              :key="i"
            >{{item}}</p>
          </div>
        </div>
      </div>

      <div class="back-btn">
        <div @click="backToList">{{lang === 'zh' ? '返回上级' : 'Return'}}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Expert",
  data() {
    return {
      editType: 0,
      currentExpert: {
        pcImgUrl: '',
        title: '',
        description: '',
        content: ''
      },
      banner: {},
      list: []
    }
  },
  methods: {
    getDesc(str) {
      const list = str.split('|');
      if(list.length <= 1) {
        return list[0];
      } else {
        return list.join('、');
      }
    },
    getIntro(str) {
      return str.split('|');
    },
    jumpDetail(item) {
      this.currentExpert = {...item};
      this.editType = 1;
      this.$router.push({
        query: {
          isDetail: true
        }
      })
    },
    backToList() {
      this.editType = 0;
      this.$router.push({
        query: {}
      })
    },
    getData(language) {
      this.$http.getOnlyContent({
        itemType: '6',
        platform: 'pc',
        language
      }).then(res => {
        this.list = res.crmOweContentMaps['601'].sort((prev, next) => {
          return prev.sort - next.sort;
        });;
        this.banner = res.imageMaps['60'][0];
      });
    },
    getDataByLang(lang) {
      if(lang === 'zh') {
        this.getData('china');
      } else {
        this.getData('english');
      }
    }
  },
  computed: {
    lang() {
      return this.$store.state.plang;
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler(v) {
        this.getDataByLang(v);
      }
    }
  },
}
</script>

<style lang="less">
.pc-home {
  .expert {
    .point-msg {
      text-align: right;
      font-size: 14px;
      margin-bottom: 80px;
    }
    .list {
      font-size: 0;
      .item {
        font-size: 1rem;
        display: inline-block;
        vertical-align: top;
        width: calc((100% - 45px) / 4);
        text-align: center;
        margin-bottom: 50px;
        margin-right: 15px;
        color: #303030;
        &:nth-child(4n) {
          margin-right: 0;
        }
        div {
          margin-bottom: 10px;
          color: #037698;
          font-weight: bold;
          cursor: pointer;
        }
        img {
          display: block;
          width: 130px;
          margin: 0 auto 25px;
          border-radius: 50%;
          cursor: pointer;
        }
      }
    }
    .content {
      font-size: 0;
      margin-bottom: 80px;
      >* {
        font-size: 1rem;
        display: inline-block;
        vertical-align: top;
      }
      img {
        width: 130px;
        margin-right: 47px;
      }
      .detail-box {
        width: calc(100% - 177px);
        >p {
          margin-bottom: 12px;
          >span {
            &:nth-child(1) {
              font-size: 20px;
              color: #0B7191;
              font-weight: bold;
              margin-right: 20px;
            }
            &:nth-child(2) {
              font-size: 14px;
            }
          }
        }
        .con-box {
          font-size: 14px;
          >p {
            text-indent: 28px;
            margin-bottom: 10px;
            line-height: 28px;
          }
        }
      }
    }
    .back-btn {
      text-align: right;
      margin: 50px 0;
      div {
        display: inline-block;
        width: 170px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        background: #037698;
        color: #fff;
        cursor: pointer;
      }
    }
  }
}
</style>
